module.exports = __webpack_public_path__ + "media/application/images/ui/external-links-495acfeb3d82b501820822ed19c0b064.png";